<script type="application/ld+json">
	{     
		"@context": "http://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
		{
		  "@type": "ListItem",
		  "position": 1,
		  "item": {
		    "@id": "https://www.protectt.ai/",
		    "name": "Home"
		  }
		},{
		  "@type": "ListItem",
		  "position": 2,
		  "item": {
		    "@id": "https://www.protectt.ai/leadership-team",
		    "name": "Leadership Team"
		  }
		}		]
	}
	</script>
<!-- Breadcrumbs -->
<div class="breadcrumbs">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <ul class="breadcrumbsul">
                    <li><a href="#">Home</a></li>
                    <li>></li>
                    <li>Leadership Team</li>
                </ul>
            </div>
        </div>
    </div>
</div>
<!-- Start Introduction -->
<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-1.webp'); background-position: right; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60 d-none d-md-block" (window:resize)="onResize($event)">
    <div class="container subbanner">
        <div class="row align-items-center">
            <div class="col-lg-8 col-md-8 col-xl-8">
                <div class="d-none d-sm-block" *ngIf="innerWidth > 768">
                    <h1 id="bnr-heading">{{heading}}</h1>
                    <h2 id="bnr-subheading">{{subheading}}</h2>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Banner For Mobile -->

<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-mobile.webp'); background-position: top; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60 d-block d-md-none">
    <div class="container subbanner">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="mt-50">
                    <!-- header background -->
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Banner Heading For Mobile -->

<div class="container d-block d-md-none" (window:resize)="onResize($event)">
    <div class="row">
        <div class="col-12">
            <div class="mt-15 mb-15 text-center" *ngIf="innerWidth <= 768">
                <h1 id="bnr-heading">{{heading}}</h1>
                <h4 id="bnr-subheading">{{subheading}}</h4>
            </div>
        </div>
    </div>
</div>

<!-- End Introduction -->
<div class="section-agency-benefit bg-gray section-pt section-pb-60">
    <div class="container">
        <div class="section-title text-center">
            <h2>Leadership Team</h2>
        </div>
        <div class="row justify-content-around align-items-start">
            <div class="col-md-4">
                <div class="card" style="border: none; background: #f8f8f8;">
                    <div class="row justify-content-center">
                        <img class="card-img-top og_image_url"
                            style="text-align: center; width: 45%; border-radius: 50%;"
                            src="assets/images/about/manish.webp" alt="Card image cap">
                    </div>
                    <div class="card-body text-center">
                        <h4>Manish Mimani</h4>
                        <h6 style="color: #D82B27; font-size: 15px;">Founder CEO</h6>

                        <p style="font-size: 95%; text-align: justify;">
                            Manish is a passionate entrepreneur with proven expertise in the Global Technology
                            Platforms, Digital Transformation, Greenfield Implementation & IT Turnaround. He is a
                            Technology Innovator focusing on Deep Tech to build Protectt.ai as the next generation
                            mobile application security platform. Manish is the laureate of the CIO100 award for three
                            consecutive years and has received many other awards for Tech & Digital Transformation.
                        </p>
                        <a href="https://www.linkedin.com/in/manish-mimani-a09b734/" target="_blank"><span
                                style="font-size: 23px; padding: 3px; color: #1A3F6E"><i class="fa fa-linkedin"
                                    aria-hidden="true"></i></span></a>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="card" style="border: none; background: #f8f8f8;">
                    <div class="row justify-content-center">
                        <img class="card-img-top" style="text-align: center; width: 45%; border-radius: 50%;"
                            src="assets/images/about/sunita.png" alt="Card image cap">
                    </div>
                    <div class="card-body text-center">
                        <h4>Sunita Handa</h4>
                        <h6 style="color: #D82B27; font-size: 15px;">Principal Advisor - Strategy</h6>

                        <p style="font-size: 95%; text-align: justify;">
                            Sunita is a Banking veteran with three decades of rich experience in large scale technology
                            & transformation initiatives. Prior to Protectt.ai, she worked as Chief General Manager at
                            State Bank of India leading Digital & Mobile Banking initiatives across
                            the Globe. She is responsible for driving key strategic initiatives, including building a
                            strong product roadmap and Go-to-Market strategy. Sunita has won many prestigious accolades
                            for her contribution to the industry.

                        </p>
                        <a href="https://www.linkedin.com/in/sunita-handa-17966820" target="_blank"><span
                                style="font-size: 23px; padding: 3px; color: #1A3F6E"><i class="fa fa-linkedin"
                                    aria-hidden="true"></i></span></a>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="card" style="border: none; background: #f8f8f8;">
                    <div class="row justify-content-center">
                        <img class="card-img-top" style="text-align: center; width: 45%; border-radius: 50%;"
                            src="assets/images/about/mohan.png" alt="Card image cap">
                    </div>
                    <div class="card-body text-center">
                        <h4>Mohanraj Selvaraj</h4>
                        <h6 style="color: #D82B27; font-size: 15px;">Head - Engineering</h6>
                        <p style="font-size: 95%; text-align: justify;">
                            Mohan is responsible for research and analysis of disruptive technologies to build stronger
                            mobile application security solutions. He has been instrumental in enabling to set up a
                            research lab for Protectt.ai and building a strong foundation for an organization.
                            He is keenly involved in assisting various customers in building high levels of mobile
                            application security ecosystem to create digital transformation roadmap of their
                            organization. He holds a B.Tech in Information Technology.
                        </p>
                        <a href="https://www.linkedin.com/in/mohanrajandroiddeveloper/" target="_blank"><span
                                style="font-size: 23px; padding: 3px; color: #1A3F6E"><i class="fa fa-linkedin"
                                    aria-hidden="true"></i></span></a>
                    </div>
                </div>
            </div>

        </div>
        <div class="row justify-content-around align-items-start">
            <div class="col-md-4 mt-70 text-center">
                <img width="40%" style="border-radius: 50%;" src="assets/images/about/pankaj.png"
                    alt="Protect Mobile Devices" />
                <div class="mt-3">
                    <h4>Pankaj Patankar</h4>
                    <h6 style="color: #D82B27; font-size: 15px;">Head – Marketing</h6>
                    <p style="font-size: 95%;" class="text-justify">
                        Pankaj Carries Around 15+ years of Experience in Brand Management and Integrated Marketing
                        Communication to Build Sustainable Branding Strategies. He has been Instrumental in Driving
                        Integrated Marketing Communication Strategies for Various IT Brands. He was
                        awarded with APAC Best Marketing Team Award for Meticulous Branding Work. Pankaj is an
                        innovative thinker and a great marketer. He is an MBA in Marketing from Bharti Vidyapeeth
                        Institute, Navi Mumbai.
                    </p>
                    <a href="https://www.linkedin.com/in/pankaj-patankar-842bab23/" target="_blank"><span
                            style="font-size: 23px; padding: 3px; color: #1A3F6E"><i class="fa fa-linkedin"
                                aria-hidden="true"></i></span></a>
                </div>
            </div>
            <div class="col-md-4 mt-70 text-center">
                <img width="40%" style="border-radius: 50%;" src="assets/images/about/ashutosh_tiwari.webp"
                    alt="Protect Mobile Devices" />
                <div class="mt-3">
                    <h4>Ashutosh Tiwari</h4>
                    <h6 style="color: #D82B27; font-size: 15px;">Vice President - Business Evangelist</h6>
                    <p style="font-size: 95%;" class="text-justify">
                        Ashutosh has 15+ years of extensive sales experience in maintaining client relations,
                        identifying new business opportunities and partnerships to drive growth and profitability. He
                        has core expertise in acquiring new customers, creating a relevant funnel, and driving business
                        growth strategies. He has been a key leader in driving sales objectives to strategies business
                        expansion plans. Ashutosh is an MBA in Marketing from Sikkim Manipal Institute of Technology,
                        Sikkim.
                    </p>
                    <a href="https://www.linkedin.com/in/ashutoshtiwari1/" target="_blank"><span style="font-size: 23px; padding: 3px; color: #1A3F6E"><i
                                class="fa fa-linkedin" aria-hidden="true"></i></span></a>
                </div>
            </div>
            <div class="col-md-4 mt-70 text-center">
                <img width="40%" style="border-radius: 50%;" src="assets/images/about/nitin_gupta.png"
                    alt="Protect Mobile Devices" />
                <div class="mt-3">
                    <h4>Nitin Gupta</h4>
                    <h6 style="color: #D82B27; font-size: 15px;">Head Channel - Partner & Customer Success</h6>
                    <p style="font-size: 95%;" class="text-justify">
                        Nitin has around two decades of experience in building a strong and sustainable Partner Business
                        Ecosystem while working in IT Technology and IT Sales for business development. He has core
                        expertise in strategic planning, channel management, a complete understanding of partner
                        business ecosystems, and a solution-driven cybersecurity business. Nitin is a competent sales
                        professional. He holds an MBA degree in Sales & Marketing.
                    </p>
                    <a href="https://www.linkedin.com/in/nitin-gupta-b6aa1633/" target="_blank"><span
                            style="font-size: 23px; padding: 3px; color: #1A3F6E"><i class="fa fa-linkedin"
                                aria-hidden="true"></i></span></a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="section-agency-benefit section-pt section-pb-60">
    <div class="container">
        <div class="section-title text-center mb-2">
            <h2><span style="color: #D82B27;">Technology Leadership </span> <span style="color: #1A3F6E;">Advisory Board
                    Members</span></h2>
        </div>
        <div class="row justify-content-around align-items-start">
            <div class="col-sm-12 text-center">
                <p class="my-3">
                    The primary objective of the Technology Leadership Advisory Board is to assist in shaping the
                    organization's technology strategy, ensuring alignment with business goals, and facilitating the
                    effective implementation of technology initiatives. Thereby building strong industry ecosystem
                    to
                    safeguard Mobile applications and contribute in Mobile Threat Defense area towards fraud
                    control.
                </p>
            </div>
        </div>
        <div class="row justify-content-around align-items-start">
            <!-- <div class="col-md-4">
                <div class="card" style="border: none;">
                    <div class="row justify-content-center">
                        <div class="col-12 text-center">
                            <strong>Chairperson</strong>
                        </div>
                        <div class="col-12 text-center">
                            <img class="card-img-top og_image_url"
                                style="text-align: center; width: 45%; border-radius: 50%;"
                                src="assets/images/about/sunita.png" alt="Card image cap">
                        </div>
                    </div>
                    <div class="card-body text-center">
                        <h4>Sunita Handa</h4>
                        <h6 style="color: #D82B27; font-size: 15px;">Principal Advisor – Strategy, Protectt.ai Ex- CGM
                            at SBI</h6>
                    </div>
                </div>
            </div> -->
            <div class="col-md-3">
                <div class="card" style="border: none;">
                    <div class="row justify-content-center">
                        <img class="card-img-top og_image_url mt-3"
                            style="text-align: center; width: 45%; border-radius: 50%;"
                            src="assets/images/about/v-sastry.webp" alt="Card image cap">
                    </div>
                    <div class="card-body text-center px-0">
                        <h4>Dr. V. N. Sastry</h4>
                        <h6 style="color: #D82B27; font-size: 15px;">Prof. and Head, Mobile and Social Media Banking
                            Lab, IDRBT, Hyderabad</h6>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card" style="border: none;">
                    <div class="row justify-content-center">
                        <img class="card-img-top og_image_url mt-3"
                            style="text-align: center; width: 45%; border-radius: 50%;"
                            src="assets/images/about/harnath-babu.webp" alt="Card image cap">
                    </div>
                    <div class="card-body text-center px-0">
                        <h4>Harnath Babu</h4>
                        <h6 style="color: #D82B27; font-size: 15px;">Partner & CIO KPMG India, Gurugram</h6>
                    </div>
                </div>
            </div>

            <div class="col-md-3 text-center">
                <div class="card" style="border: none;">
                    <div class="row justify-content-center">
                        <img class="card-img-top og_image_url mt-3"
                            style="text-align: center; width: 45%; border-radius: 50%;"
                            src="assets/images/about/guhan-muthusamy.webp" alt="Card image cap">
                    </div>
                    <div class="card-body text-center px-0">
                        <h4>Guhan Muthusamy</h4>
                        <h6 style="color: #D82B27; font-size: 15px;">Co-founder at Mindgate Solutions Pvt. Ltd.</h6>
                    </div>
                </div>
            </div>
            <div class="col-md-3 text-center">
                <div class="card" style="border: none;">
                    <div class="row justify-content-center">
                        <img class="card-img-top og_image_url mt-3"
                            style="text-align: center; width: 45%; border-radius: 50%;"
                            src="assets/images/about/navneethan-m.webp" alt="Card image cap">
                    </div>
                    <div class="card-body text-center">
                        <h4>Navaneethan M</h4>
                        <h6 style="color: #D82B27; font-size: 15px;">Chief Information Security Officer at Tata Play
                        </h6>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

<!-- Start Agency Benefits Area -->
<!-- <div class="section-agency-benefit bg-gray section-pt section-pb-60">
    <div class="container">
        <div  class="section-title text-center">
            <h2>Investors</h2>
        </div>
        <div  class="row justify-content-around align-items-start">
            <div class="col-md-5 text-center">
                <img width="30%" style="border-radius: 50%;" src="assets/images/about/george.png" alt="Protect Mobile Devices" />
                <div class="mt-3">
                    <h4>George Sam</h4>
                    <h6 style="color: #D82B27; font-size: 15px;">Co-founder - Mindgate Solutions</h6>

                    <p style="font-size: 95%;" class="text-justify">
                        George brings in 21 Years of Experience in Servicing the BFSI Customers in India, The Middle East, & South East Asia. He has a Proven Track Record on Building & Leading Technology Products with a Key Focus on Business Management Specifically on Managing
                        Top-Line Growth & Profitability Along with Maintaining Client Relations with the Company.
                    </p>
                    <a href="https://www.linkedin.com/in/george-sam-440a2a58/" target="_blank"><span
                            style="font-size: 23px; padding: 3px; color: #1A3F6E"><i
                                class="fa fa-linkedin" aria-hidden="true"></i></span></a>
                </div>
            </div>
            <div class="col-md-5 text-center">
                <img width="30%" style="border-radius: 50%;" src="assets/images/about/guhan.png" alt="Protect Mobile Devices" />
                <div class="mt-3">
                    <h4>Guhan Muthusamy</h4>
                    <h6 style="color: #D82B27; font-size: 15px;">Co-founder - Mindgate Solutions</h6>

                    <p style="font-size: 95%;" class="text-justify">
                        Guhan is a Co-Founder & the Chief Architect at Mindgate. Heading Product, Technology & Delivery, He is Responsible for All Product Architectures Along with Strategic Technology Decisions for Retail, Corporate & Government Agencies. He Plays a Pivotal
                        in Ensuring an Open, Scalable, Secure Architecture Platform to Meet All the Needs of Various Financial Institutions.
                    </p>
                    <a href="https://www.linkedin.com/in/guhan-m-8447bab/" target="_blank"><span
                            style="font-size: 23px; padding: 3px; color: #1A3F6E"><i
                                class="fa fa-linkedin" aria-hidden="true"></i></span></a>
                </div>
            </div>

        </div>
    </div>
</div> -->
<!-- End Agency Benefits Area -->